import { render } from "./Controls.vue?vue&type=template&id=5b3a50f7&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"

import "./Controls.vue?vue&type=style&index=0&id=5b3a50f7&lang=scss"
import "./Controls.vue?vue&type=style&index=1&id=5b3a50f7&lang=scss"
import "./Controls.vue?vue&type=style&index=2&id=5b3a50f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3a50f7"]])

export default __exports__